import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function LockIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.8" y="10.4" width="14.4" height="10.4" rx="2" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M7.2 10.4V7.2C7.2 4.5492 9.3492 2.4 12 2.4C14.6508 2.4 16.8 4.5492 16.8 7.2V10.4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="15.6" r="1.2" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}

export default LockIcon;
